import React, { useState, useContext } from 'react';
import { Navbar, Container, Nav, Offcanvas, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSignOutAlt, FaFileAlt, FaMapMarkedAlt } from 'react-icons/fa';
import Logo from '../assets/Logo-Negro.png';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';
import { getEmpresaActual } from '../config/empresas-demo';
import RoleSwitcher from './RoleSwitcher';
// import VersionSwitcher from './VersionSwitcher';
import '../styles/NavbarEmployes.css';
import { usePermisos } from '../hooks/usePermisos';
import { openHeatmap, HEATMAP_PERMISSION, HEATMAP_CONFIG } from '../config/heatmap.config';

function NavbarEmpleado() {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const offcanvasId = 'offcanvasNavbarEmpleado';
  const { setUsuario } = useContext(UserContext);
  const empresaActual = getEmpresaActual();
  const logoActual = empresaActual.logo || Logo;
  
  // Verificar si el usuario es administrador
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.PortalRRHH === 1 || user.esAdmin === true;
  
  // Sistema de permisos
  const { tienePermiso } = usePermisos();


  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('user_permisos');
    localStorage.removeItem('user_permisos_timestamp');
    setUsuario(null); // limpia el estado en memoria
    navigate('/');
  };

  return (
    <Navbar expand="lg" className="navbar-empleado" variant="light" bg="light">
      <Container fluid>
        <Navbar.Brand as={Link} to="/home" className="mx-auto mx-lg-0">
          <img src={Logo} alt="SiBus Logo" className="navbar-logo" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls={offcanvasId}
          onClick={() => setShowMenu(true)}
        />

        <Navbar.Collapse className="d-none d-lg-block">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/home" className="nav-link">Inicio</Nav.Link>
            <Nav.Link as={Link} to="/home/recibos" className="nav-link">Recibos</Nav.Link> 
            <Nav.Link as={Link} to="/home/beneficios" className="nav-link">Beneficios</Nav.Link>
            <Nav.Link as={Link} to="/home/procedimientos" className="nav-link">Procedimientos</Nav.Link>
            {/* <Nav.Link as={Link} to="/home/capacitaciones" onClick={() => setShowMenu(false)}>Capacitaciones</Nav.Link> */}
            
            {/* Acceso al Mapa de Calor */}
            {tienePermiso(HEATMAP_PERMISSION) && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-heatmap">{HEATMAP_CONFIG.title}</Tooltip>}
              >
                <Nav.Link 
                  onClick={(e) => {
                    e.preventDefault();
                    openHeatmap();
                  }}
                  className="nav-link"
                  style={{ cursor: 'pointer' }}
                >
                  <FaMapMarkedAlt size={18} style={{ color: '#667eea' }} />
                </Nav.Link>
              </OverlayTrigger>
            )}
            
            {/* Switch de rol para administradores */}
            {isAdmin && <RoleSwitcher />}
            
            {/* Cambiar a v2.0 */}
            {/* <VersionSwitcher /> */}
            
            <Button variant="outline-danger" size="sm" className="logout-btn ms-3" onClick={handleLogout}>
              <FaSignOutAlt className="me-2" /> Cerrar sesión
            </Button>
          </Nav>
        </Navbar.Collapse>

        <Offcanvas
          show={showMenu}
          onHide={() => setShowMenu(false)}
          placement="end"
          id={offcanvasId}
          className="offcanvas-empleado"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menú</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="flex-column">
              <Nav.Link as={Link} to="/home" onClick={() => setShowMenu(false)}>Inicio</Nav.Link>
              <Nav.Link as={Link} to="/home/recibos" className="nav-link">Recibos</Nav.Link>
              <Nav.Link as={Link} to="/home/procedimientos" onClick={() => setShowMenu(false)}>Procedimientos</Nav.Link>
              <Nav.Link as={Link} to="/home/beneficios" onClick={() => setShowMenu(false)}>Beneficios</Nav.Link>
              {/* <Nav.Link as={Link} to="/home/capacitaciones" onClick={() => setShowMenu(false)}>Capacitaciones</Nav.Link> */}
              
              {/* Acceso al Mapa de Calor - Móvil */}
              {tienePermiso(HEATMAP_PERMISSION) && (
                <Nav.Link 
                  onClick={() => {
                    openHeatmap();
                    setShowMenu(false);
                  }}
                  className="nav-link"
                  style={{ cursor: 'pointer' }}
                >
                  <FaMapMarkedAlt className="me-2" style={{ color: '#667eea' }} />
                  {HEATMAP_CONFIG.title}
                </Nav.Link>
              )}

              <div className="mt-3 pt-3 border-top">
                <Button
                  variant="outline-dark"
                  className="w-100"
                  onClick={() => {
                    handleLogout();
                    setShowMenu(false);
                  }}
                >
                  <FaSignOutAlt className="me-2" /> Cerrar sesión
                </Button>
              </div>
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
}

export default NavbarEmpleado;
